import { render, staticRenderFns } from "./UserSectionPopover.vue?vue&type=template&id=955e5e84&"
import script from "./UserSectionPopover.vue?vue&type=script&lang=js&"
export * from "./UserSectionPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserSectionPopover.vue"
export default component.exports